import { BotMessageSquare } from 'lucide-react'

interface VigiaIconProps {
  size?: number
  className?: string
}

export function VigiaIcon({ size = 18, className = '' }: VigiaIconProps) {
  return <BotMessageSquare size={size} className={className} />
}
